import GridLayout from "components/GridLayout";
import Header from "../components/Header";
import Section from "components/Section";
import Banner from "components/Banner";
import Layout from "components/Layout";
import Title from "components/Title";
import Image from "next/image";

export default function DevelopPage() {
  return (
    <Layout>
      <Header
        className="bg-[url('/images/persons/johanna-boulos.png')]"
        title="Solutions d'apprentissages rapides"
      />
      <main>
        <Banner
          text={
            "Nous concevons et réalisons des solutions créatives, innovantes d'apprentissage en ligne."
          }
          color="red"
        />
        <div className="bg-pink-salt">
          <Section className="pb-36 pt-24">
            <GridLayout>
              <article>
                <Title color="green" title={"Le secret: notre collaboration"} />
                <p className="text-r-3xl mb-16 mt-8 font-semibold leading-1.2 text-neutral-600">
                  Votre expertise du contenu et à notre savoir-faire en
                  pédagogie, en sciences de l&apos;apprentissage et en
                  technologies éducatives sont la clé pour atteindre de vos
                  objectifs avec des résultats mesurables, rapides et à grande
                  échelle.
                </p>
                <article className="text-r-2xl rounded-lg bg-white px-10 py-16">
                  <h3 className="text-r-4xl font-bold text-green-500">
                    Les raisons de notre succès
                  </h3>
                  <div className="text-black">
                    <p className="my-8 font-bold leading-1.2">
                      Nos solutions sont adaptés selon les projets, le type
                      d’apprentissage, le résultat souhaité.
                    </p>
                    <p className="mb-4 font-bold">Ainsi ils:</p>
                    <ul className="block list-disc space-y-4 pl-8">
                      <li>
                        Respectent le temps alloué et du budget du client.
                      </li>
                      <li>Activent la participation des apprenants.</li>
                      <li>S’adaptent aux besoins précis des participants.</li>
                      <li>
                        Augmentent la similarité avec les environnements de
                        travail.
                      </li>
                      <li>Favorisent le transfert des apprentissages.</li>
                      <li>Développent les comportements attendus.</li>
                    </ul>
                  </div>
                </article>
              </article>
              <article>
                <Image
                  className="rounded-large mb-16"
                  src="/images/mens-working.png"
                  width={470}
                  height={348}
                  alt="mens-working"
                />
                <article>
                  <h3 className="text-r-4xl w-4/5 font-bold text-green-500">
                    Adaptation et conception sur mesure de formations innovantes
                    alignées sur les objectifs, la vision et les orientations de
                    l’organisation.
                  </h3>
                  <ul className="text-r-xl mt-14 space-y-5 font-bold text-neutral-700">
                    <li>Capsules e-learning rapide personnalisées</li>
                    <li>Aides à la tâche interactives</li>
                    <li>Applications mobiles</li>
                    <li>Micro learning</li>
                    <li>Cours avec « gamification »</li>
                    <li>Tutoriels vidéo</li>
                    <li>Vidéos informatives</li>
                    <li>Simulations</li>
                    <li>Podcasts</li>
                    <li>Webinaires</li>
                  </ul>
                </article>
              </article>
            </GridLayout>
          </Section>
        </div>
      </main>
    </Layout>
  );
}
